export const defaultAuthConfig = {
  isDefault: true,
  logo: '/images/logo/elevateos-logo-wide-black.svg',
  photo: '/images/auth/default/photo.png',
  header: 'auth:authConfig.header.default',
  appName: 'ElevateOS',
  appLogo: '/images/auth/default/app.png',
  appStore: 'https://apps.apple.com/us/app/elevated-living/id1382244071',
  playStore: 'https://play.google.com/store/apps/details?id=com.elevatedliving',
}

// Note: For few domains the layout is customized
export const authConfigs = {
  'company-name.redvike.rocks': {
    isDefault: false,
    logo: '/images/logo/elevateos-logo-wide-black.svg',
    header: 'auth:authConfig.header.testCompany',
    photo: '/images/bg.jpg',
    appName: 'ElevateOS',
    appLogo: '/images/auth/default/app.png',
    appStore: 'https://apps.apple.com/us/app/elevated-living/id1382244071',
    playStore: 'https://play.google.com/store/apps/details?id=com.elevatedliving',
  },
  'arrive.elevatedliving.com': {
    isDefault: false,
    logo: '/images/auth/arrive/arrive-logo.svg',
    photo: '/images/auth/arrive/arrive-photo.png',
    header: 'auth:authConfig.header.arrive',
    appName: 'Arrive Luxury Communities',
    appLogo: '/images/auth/arrive/arrive-app.png',
    appStore: 'https://apps.apple.com/us/app/arrive-luxury-communities/id6504909420',
    playStore: 'https://play.google.com/store/apps/details?id=com.ArriveLuxuryCommunities',
  },
  '700.elevatedliving.com': {
    isDefault: false,
    logo: '/images/auth/700river/700river-logo.svg',
    photo: '/images/auth/700river/700river-photo.png',
    header: 'auth:authConfig.header.residentPortal',
    appName: '700 River',
    appLogo: '/images/auth/700river/700river-app.png',
    appStore: 'https://apps.apple.com/app/700-river/id6612039338',
    playStore: 'https://play.google.com/store/apps/details?id=com.River700',
  },
  'willowbridge.elevatedliving.com': {
    isDefault: false,
    logo: '/images/auth/willowbridge/WillowBridge_Logo.svg',
    photo: '/images/auth/willowbridge/WillowBridge_photo.png',
    header: 'auth:authConfig.header.residentPortal',
    appName: 'Willow',
    appLogo: '/images/auth/willowbridge/WillowBridge_App.png',
    appStore: 'https://apps.apple.com/us/app/elevated-living/id1382244071',
    playStore: 'https://play.google.com/store/apps/details?id=com.elevatedliving',
    hideAppLinks: true,
  },
}
